module.exports = __webpack_public_path__ + "img/minus-circle.af8e97b8.svg";